//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { storageRecordApi, storageRecordUsersApi } from '@/api/administration';
export default {
  name: 'Record',
  components: {},
  props: {
    formData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      drawer: false,
      direction: 'rtl',
      loading: false,
      where: {
        page: 1,
        limit: 15,
        name: '',
        types: '',
        storage_id: null,
        frame_id: '',
        card_id: ''
      },
      usersWhere: {
        types: '',
        storage_id: null
      },
      index: 0,
      total: 0,
      tableData: [],
      onlyPerson: false,
      openStatus: false,
      activeDepartment: {},
      option: [],
      userOptions: []
    };
  },
  watch: {
    formData: {
      handler: function handler(nVal) {
        if (nVal.type === 0) {
          this.option = [{
            value: '',
            label: '全部'
          }, {
            value: 0,
            label: '入库'
          }, {
            value: 1,
            label: '领用'
          }];
        } else {
          this.option = [{
            value: '',
            label: '全部'
          }, {
            value: 0,
            label: '入库'
          }, {
            value: 1,
            label: '领用'
          }, {
            value: 2,
            label: '归还'
          }, {
            value: 3,
            label: '维修'
          }, {
            value: 4,
            label: '报废'
          }, {
            value: 5,
            label: '维修处理'
          }];
        }
      },
      deep: true
    }
  },
  methods: {
    handleClose: function handleClose() {
      this.drawer = false;
      this.where.types = '';
      this.where.name = '';
      this.where.card_id = '';
      this.where.frame_id = '';
      this.index = 0;
      this.where.page = 1;
    },
    openBox: function openBox() {
      this.drawer = true;
      this.getTableData();
      this.getOptionData();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.where.limit = val;
      this.getTableData();
    },
    getOptionData: function getOptionData() {
      var _this = this;
      storageRecordUsersApi(this.usersWhere).then(function (res) {
        _this.userOptions = res.data || [];
        _this.userOptions.unshift({
          id: '',
          name: '全部',
          types: -1
        });
      });
    },
    pageChange: function pageChange(page) {
      this.where.page = page;
      this.getTableData();
    },
    getSearch: function getSearch() {
      this.where.page = 1;
      this.getTableData();
    },
    reset: function reset() {
      this.where.types = '';
      this.where.name = '';
      this.where.card_id = '';
      this.where.frame_id = '';
      this.index = 0;
      this.where.page = 1;
      this.getSearch();
    },
    // 记录
    getTableData: function getTableData() {
      var _this2 = this;
      if (this.index) {
        var data = this.userOptions[this.index];
        if (data.types === 0) {
          this.where.card_id = data.id;
          this.where.frame_id = '';
        } else {
          this.where.card_id = '';
          this.where.frame_id = data.id;
        }
      } else {
        this.where.frame_id = '';
        this.where.card_id = '';
      }
      storageRecordApi(this.where).then(function (res) {
        _this2.tableData = res.data.list || [];
        _this2.total = res.data.count;
      });
    }
  }
};